module.exports = {"370523001":"广饶街道","370523002":"乐安街道","370523101":"大王镇","370523102":"稻庄镇","370523104":"丁庄镇","370523106":"李鹊镇","370523107":"大码头镇","370523108":"花官镇","370523109":"陈官镇","370523400":"东营农业高新技术产业示范区","370523401":"广饶滨海新区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370523.json
// module id = 1289
// module chunks = 0